import HierarchicalReportLayout, { formatters } from 'components/hierarchical-report/Layout'

import siteVerificationStore from '../../stores/siteVerification'

import { SiteVerificationReportProvider, useSiteVerificationReportStore } from './store'

export default class SiteVerificationReport extends HierarchicalReportLayout {
  store = siteVerificationStore
  title = 'Verifications'

  useNewStore = () => {
    const store = useSiteVerificationReportStore()
    const { report: { useLoad } } = store
    useLoad()
    return store
  }

  configure = {
    filterby: {
      options: [{
        value: 'publisher',
        get label() {
          return <formatters.Loadable isLoading={siteVerificationStore.publisher.isLoading}>Publisher</formatters.Loadable>
        },
        options: siteVerificationStore.publisher.fetchData,
      }, {
        value: 'allocation',
        get label() {
          return <formatters.Loadable isLoading={siteVerificationStore.allocation.isLoading}>Allocation</formatters.Loadable>
        },
        options: siteVerificationStore.allocation.fetchData,
      },
      {
        value: 'cmsVerificationsSite',
        get label() {
          return <formatters.Loadable>Verification</formatters.Loadable>
        },
        options: siteVerificationStore.verification.fetchData,
      },
      {
        value: 'payouttype',
        get label() {
          return <formatters.Loadable>Payout type</formatters.Loadable>
        },
        options: async () => [
          { value: "cpc", label: "CPC", getLabel: () => "CPC", getValue: () => "cpc" },
          { value: "cpa", label: "CPA", getLabel: () => "CPA", getValue: () => "cpa" },
          { value: "cpm", label: "CPM", getLabel: () => "CPM", getValue: () => "cpm" },
          { value: "cpl", label: "CPL", getLabel: () => "CPL", getValue: () => "cpl" },
          { value: "custom", label: "CUSTOM", getLabel: () => "CUSTOM", getValue: () => "custom" },
        ],
      }],
    },
    groupby: {
      default: ['allocation', 'verificationType'],
      options: [
        { value: 'publisher', label: 'Publisher', group: 'Traffic' },
        { value: 'allocation', label: 'Allocation', group: 'Traffic' },
        { value: 'conversiontype', label: 'Conversion Type', group: 'Traffic' },
        { value: 'payouttype', label: 'Payout Type', group: 'Traffic' },
        { value: 'subId', label: 'SubID 1', group: 'Traffic' },
        { value: 'subId2', label: 'SubID 2', group: 'Traffic' },
        { value: 'subId3', label: 'SubID 3', group: 'Traffic' },

        { value: 'verificationType', label: 'Verification Type', group: 'Traffic' },

        { value: 'hour', label: 'Hour', group: 'Full Time' },
        { value: 'day', label: 'Day', group: 'Full Time' },
        { value: 'month', label: 'Month', group: 'Full Time' },
        { value: 'year', label: 'Year', group: 'Full Time' },

        // { value: 'hour_unittime', label: 'Hour', group: 'Unit Time' },
        // { value: 'day_unittime', label: 'Day', group: 'Unit Time' },
        // { value: 'weekday_unittime', label: 'Weekday', group: 'Unit Time' },
        // { value: 'month_unittime', label: 'Month', group: 'Unit Time' },

        { value: 'city', label: 'City', group: 'Consumer' },
        { value: 'state', label: 'State', group: 'Consumer' },
        { value: 'emaildomain', label: 'Email Domain', group: 'Consumer' },
        { value: 'age', label: 'Age', group: 'Consumer' },
        { value: 'gender', label: 'Gender', group: 'Consumer' },
      ],
    },
    metrics: {
      default: ['uniqUser', 'completed', 'converted', 'cost'],
      options: [
        { value: 'uniqUser', label: 'Unique Users', group: 'Default' },
        { value: 'uniqSession', label: 'Unique Sessions', group: 'Default' },
        { value: 'cost', label: 'Cost', group: 'Default' },

        { value: 'converted', label: 'Converted', group: 'Built-in' },
        { value: 'completed', label: 'Completed', group: 'Built-in' },

        { value: 'uniqUserPC', label: 'Unique Users %', group: 'Ratio' },
        { value: 'uniqSessionPC', label: 'Unique Sessions %', group: 'Ratio' },
        { value: 'convertedPC', label: 'Converted %', group: 'Ratio' },
        { value: 'completedPC', label: 'Completed %', group: 'Ratio' },
      ],
    },
    sortby: {
      default: ['total desc'],
      options: [
        { value: 'total', label: 'Verifications', group: 'Default' },
      ],
    },
  }

  metricColumns = [{
    dataField: 'uniqUser',
    customSort: true,
    text: "Uniq. Users",
    formatter: formatters.parentPercent(formatters.number, 'uniqUser'),
  }, {
    dataField: 'uniqUserPC',
    customSort: true,
    text: "Uniq. Users (%)",
    formatter: cell => formatters.percent(cell),
  }, {
    dataField: 'uniqSession',
    customSort: true,
    text: "Uniq. Session",
    formatter: formatters.parentPercent(formatters.number, 'uniqSession'),
  }, {
    dataField: 'uniqSessionPC',
    customSort: true,
    text: "Uniq. Session (%)",
    formatter: cell => formatters.percent(cell),
  }, {
    dataField: 'completed',
    customSort: true,
    text: "Completed",
    formatter: formatters.drilldown(this.newTab, 'completed'),
  }, {
    dataField: 'completedPC',
    customSort: true,
    text: "Completed (%)",
    formatter: cell => formatters.percent(cell),
  }, {
    dataField: 'converted',
    customSort: true,
    text: "Converted",
    formatter: formatters.drilldown(this.newTab, 'converted'),
  }, {
    dataField: 'convertedPC',
    customSort: true,
    text: "Converted (%)",
    formatter: cell => formatters.percent(cell),
  }, {
    dataField: 'cost',
    customSort: true,
    text: "Cost",
    formatter: formatters.money(3),
  }]

  get columns() {
    const { metrics, groupby } = this.state || {}
    const metricColumns = this.metricColumns.filter(d => metrics && metrics.includes(d.dataField))

    return [
      {
        dataField: 'value',
        text: groupby && groupby.map(formatters.groupsText).join(' / '),
        customSort: true,
        sortValue: row => row.name || row.keyString || row.value,
        formatter: formatters.name,
      },
      {
        dataField: 'total',
        customSort: true,
        text: "Total",
        formatter: formatters.drilldown(this.newTab, 'total'),
      },
      ...metricColumns,
    ]
  }

  ReportProvider = ({ children }) => <SiteVerificationReportProvider>
    {children}
  </SiteVerificationReportProvider>
}
